import { TowerGameDifficulty } from '@/components/games/tower/types'
import generateFloat from '../generateFloat'

const LEVEL_MAP = {
  easy: { count: 3, size: 4 },
  medium: { count: 2, size: 3 },
  hard: { count: 1, size: 2 },
  expert: { count: 1, size: 3 },
  master: { count: 1, size: 4 },
} as const

export type CalculateTowerBetResultOptions = {
  serverSeed: string
  clientSeed: string
  nonce: number
  difficulty: TowerGameDifficulty
}

export default function calculateTowerBetResult(
  options: CalculateTowerBetResultOptions
) {
  const { serverSeed, clientSeed, nonce, difficulty } = options

  const values: boolean[][] = []

  const { count, size } = LEVEL_MAP[difficulty]

  for (let i = 0; i < 9; i++) {
    const numbers: number[] = Array.from(Array(size)).map((_, index) => index)

    for (let j = 0; j < count; j++) {
      const float = generateFloat({
        serverSeed,
        clientSeed,
        nonce,
        round: j + count * i,
      })
      const k = j + Math.floor(float * (numbers.length - j))
      const temp = numbers[j]
      numbers[j] = numbers[k]
      numbers[k] = temp
    }

    numbers.splice(count)

    values.push(
      Array.from(Array(size)).map((_, index) => numbers.includes(index))
    )
  }

  return values
}
